import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class SourcingAssetAdjustmentService {

  constructor(private http: HttpClient) { }

  /**
   * Generic method to fetch JSON objects from the backend
   * CRITICAL: Uses GET method with query params (matching AngularJS behavior)
   */
  getJsonObject(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Merge parameters (matching AngularJS JsonObjectFactory.getJSONObj)
    let requestParams = _.merge({}, globalService, filterParams, params);
    
    // Remove checkLockedbj if present (matching AngularJS behavior)
    delete requestParams.checkLockedbj;
    
    // Convert to HttpParams for GET request
    let httpParams = new HttpParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        httpParams = httpParams.set(key, requestParams[key].toString());
      }
    });

    // Use GET method with query params (matching AngularJS)
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  /**
   * Save sourcing asset adjustment
   */
  saveSourcingAssetAdjustment(
    baseUrl: string,
    returnObj: any,
    transactionDetails: any[],
    otherInfo: any,
    lockObj: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=zlxjsx`;

    // Prepare clob_data and clob_settings
    const jsonObj = JSON.stringify(transactionDetails);
    const clobSettings = JSON.stringify({
      sso_id: otherInfo.sso_id,
      tax_year: otherInfo.tax_year,
      scenario: otherInfo.scenario,
      jcd_key: otherInfo.jcd_key
    });

    // Merge parameters
    let params = _.merge({}, globalService, filterParams);
    params = _.extend({ clob_data: jsonObj }, params);
    params = _.extend({ clob_settings: clobSettings }, params);
    params = _.extend({
      sso_id: otherInfo.sso_id,
      tax_year: otherInfo.tax_year,
      scenario: otherInfo.scenario,
      jcd_key: otherInfo.jcd_key,
      screen_key: otherInfo.SCREEN_KEY
    }, params);
    params.process_name = "SRC_SAVE";

    // CRITICAL: Add scenarioCode and is_issue_key_enabled (matching other zlxjsx services)
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || globalService?.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";

    // CRITICAL: Add checkLockedbj (matching AngularJS behavior)
    // For CREATE mode: Use lockObj.lockingObj (just combination_key)
    // For EDIT/UPDATE mode: Use rowData to build full checkLockedbj structure with leid, me_code, etc.
    if (rowData && rowData.COMBINATION_KEY) {
      // EDIT/UPDATE mode: Build checkLockedbj from rowData with full details
      const checkLockedbj = [{
        leid: rowData.LEID,
        me_code: rowData.ME_CODE || rowData.ME,
        cdr_number: rowData.CDR_NO || rowData.TAX_CODE,
        consol_group_key: rowData.CONSOL_GROUP_KEY,
        reporting_period: rowData.REPORTING_PERIOD,
        combination_key: rowData.COMBINATION_KEY,
        scenario_key: parseInt(filterParams.scenario || params.scenario)
      }];
      params.checkLockedbj = JSON.stringify(checkLockedbj);
    } else if (lockObj && lockObj.lockingObj && lockObj.lockingObj.length > 0) {
      // CREATE mode: Use lockObj.lockingObj (just combination_key)
      params.checkLockedbj = JSON.stringify(lockObj.lockingObj);
    }

    // Convert to URL-encoded format
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}


